// ==================== TRANSFORMATION PLAYBOOKS ====================

export const TRANSFORMATION_PLAYBOOKS = {
  byIndustry: {
    healthcare: {
      playbook: 'Healthcare AI Transformation Playbook',
      phases: [
        {
          phase: 'Clinical Readiness',
          activities: ['Data standardization', 'Clinical workflow analysis', 'Stakeholder alignment'],
          duration: '3 months',
          successCriteria: ['Data quality > 95%', 'Clinician buy-in > 70%']
        },
        {
          phase: 'Pilot Implementation',
          activities: ['AI-assisted diagnosis', 'Predictive monitoring', 'Administrative automation'],
          duration: '6 months',
          successCriteria: ['Pilot success > 80%', 'ROI > 200%']
        },
        {
          phase: 'Enterprise Scale',
          activities: ['Multi-department rollout', 'Integration with EHR', 'Continuous improvement'],
          duration: '12 months',
          successCriteria: ['50%+ adoption', 'Cost reduction > 20%']
        }
      ],
      useCasePrioritization: {
        highValueLowComplexity: ['Automated scheduling', 'Billing automation', 'Patient triage'],
        highValueHighComplexity: ['Diagnostic imaging', 'Drug discovery', 'Personalized medicine'],
        lowValueLowComplexity: ['Report generation', 'Data entry', 'Appointment reminders'],
        lowValueHighComplexity: ['Robot-assisted surgery', 'Genomic analysis']
      }
    },
    finance: {
      playbook: 'Financial Services AI Playbook',
      phases: [
        {
          phase: 'Risk & Compliance',
          activities: ['Fraud detection', 'AML/KYC automation', 'Regulatory reporting'],
          duration: '3 months',
          successCriteria: ['Fraud detection > 95%', 'Compliance automation > 80%']
        },
        {
          phase: 'Customer Intelligence',
          activities: ['Personalization', 'Credit scoring', 'Churn prediction'],
          duration: '6 months',
          successCriteria: ['Customer satisfaction > 85%', 'Retention improvement > 15%']
        },
        {
          phase: 'Operational Excellence',
          activities: ['Process automation', 'Trading optimization', 'Risk management'],
          duration: '9 months',
          successCriteria: ['Cost reduction > 25%', 'ROI > 300%']
        }
      ],
      useCasePrioritization: {
        highValueLowComplexity: ['Transaction monitoring', 'Report automation', 'Customer onboarding'],
        highValueHighComplexity: ['Algorithmic trading', 'Credit risk modeling', 'Market prediction'],
        lowValueLowComplexity: ['Email automation', 'Document processing', 'Data validation'],
        lowValueHighComplexity: ['Quantitative strategies', 'Alternative data analysis']
      }
    },
    manufacturing: {
      playbook: 'Smart Manufacturing AI Playbook',
      phases: [
        {
          phase: 'Asset Intelligence',
          activities: ['Predictive maintenance', 'Quality inspection', 'Energy optimization'],
          duration: '4 months',
          successCriteria: ['Downtime reduction > 30%', 'Quality improvement > 20%']
        },
        {
          phase: 'Production Optimization',
          activities: ['Scheduling optimization', 'Yield improvement', 'Supply chain visibility'],
          duration: '8 months',
          successCriteria: ['OEE > 80%', 'Throughput increase > 25%']
        },
        {
          phase: 'Autonomous Operations',
          activities: ['Self-optimizing systems', 'Digital twin', 'Closed-loop control'],
          duration: '18 months',
          successCriteria: ['Autonomy > 50%', 'Cost reduction > 35%']
        }
      ],
      useCasePrioritization: {
        highValueLowComplexity: ['Energy monitoring', 'Inventory tracking', 'Quality dashboards'],
        highValueHighComplexity: ['Predictive maintenance', 'Autonomous quality control', 'Digital twin'],
        lowValueLowComplexity: ['Report generation', 'Data collection', 'Visual inspection'],
        lowValueHighComplexity: ['Fully autonomous production', 'Self-healing systems']
      }
    }
  },
  
  implementationGuides: {
    agileAI: {
      name: 'Agile AI Implementation',
      principles: ['Iterative delivery', 'Continuous feedback', 'Cross-functional teams'],
      ceremonies: ['Daily standups', 'Sprint planning', 'Retrospectives', 'Demo days'],
      metrics: ['Velocity', 'Cycle time', 'Defect rate', 'Customer satisfaction']
    },
    stageGate: {
      name: 'Stage-Gate Implementation',
      stages: [
        { gate: 'Ideation', criteria: 'Problem validated', decision: 'Go/No-Go' },
        { gate: 'Prototype', criteria: 'Technical feasibility', decision: 'Go/No-Go' },
        { gate: 'Pilot', criteria: 'Business value proven', decision: 'Go/No-Go' },
        { gate: 'Scale', criteria: 'ROI validated', decision: 'Go/No-Go' }
      ]
    }
  },
  
  successCriteria: {
    technical: [
      'Model accuracy > 90%',
      'Latency < 100ms',
      'Availability > 99.9%',
      'Scalability proven'
    ],
    business: [
      'ROI > 200%',
      'Cost reduction > 20%',
      'Revenue uplift > 15%',
      'Payback < 12 months'
    ],
    adoption: [
      'User adoption > 70%',
      'Process integration complete',
      'Training completed',
      'Support established'
    ]
  }
};